export const config = {
  signalingUrl: import.meta.env.VITE_SIGNALING_URL ?? 'wss://signal.duocast.ai',
  stunUrls: ['stun:stun.l.google.com:19302', 'stun:stun1.l.google.com:19302'],
  turnUrl: import.meta.env.VITE_TURN_URL ?? 'turn:turn.duocast.ai:3478',
  /** Metered TURN API endpoint. Set VITE_METERED_API_URL in env. */
  meteredApiUrl: import.meta.env.VITE_METERED_API_URL ?? '',
  stages: { voice: 30, filtered: 90 },
  heartbeatInterval: 30_000,
  version: __APP_VERSION__,
} as const;
